import React, { useEffect, useState } from 'react'
import ReceiveConfirmationView from './components/ReceiveConfirmationView'
import Error from 'shared/components/Error'
import { addToGoogleDataLayer } from 'shared/const/utls.js'
import { useSelector } from 'react-redux';
import { withTranslation } from 'react-i18next'

const ReceiveConfirmation = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  const addressTypeChange = useSelector((state) => state.app.addressTypeChange);
  useEffect(() => {
    addToGoogleDataLayer('receive-confirmation', 'Pay a Debt', i18n.language, addressTypeChange)
    window.scrollTo(0, 0)
  }, [i18n.language, addressTypeChange])

  return isError ? <Error /> : <ReceiveConfirmationView setIsError={setIsError} />
}

export default withTranslation('common')(ReceiveConfirmation)
